exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ic-pagination {\n    display: block;\n}\n.ic-pagination {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n        flex-direction: row;\n    -ms-flex-pack: center;\n        justify-content: center;\n}\n.ic-pagination__item {\n    width: 24px;\n    height: 24px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    color: rgba(0, 0, 0, .88);\n}\n.ic-pagination__item {\n    cursor: pointer;\n}\n.ic-pagination__item--disable {\n    cursor: not-allowed;\n}\n.ic-pagination__item--disable {\n    color: rgba(0, 0, 0, .64);\n}\n.ic-pagination__item--active,\n.ic-pagination__item:not(.ic-pagination__item--disable):hover {\n    color: #0384ff;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/pagination/pagination.component.css
// module id = ../../../../../src/app/layout/pagination/pagination.component.css
// module chunks = 3